import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import useHttp from "../../../hooks/use-http";



const FarmerWiseMIS = () => {
  const [datalist, setDatalist] = useState([]);

  const [serviceId, setServiceId] = useState("none");

  const logo = localStorage.getItem("organizationIcon")
    ? `${process.env.REACT_APP_FILE_URL}${localStorage.getItem("organizationIcon")}`
    : "/dist/img/TomatoJOLogo.jpg";


  useEffect(() => {
    var urlpathname = window.location.pathname;
    var roleAllocation = JSON.parse(localStorage.getItem("RoleAllocation"));

    if (roleAllocation && roleAllocation.length > 0) {
      //console.log("roleAllocation", roleAllocation);

      var roleAllocationFilterList = roleAllocation.filter(
        (item) => item.serviceUrl == urlpathname
      );
      console.log("roleAllocationFilterList", roleAllocationFilterList);
      if (roleAllocationFilterList && roleAllocationFilterList.length > 0) {
        var itemselected = roleAllocationFilterList[0];

        console.log(itemselected);

        setServiceId(itemselected.serviceId);
         

          var localstrKey="service"+itemselected.serviceId

    console.log("localstrKey",localStorage.getItem(localstrKey))
     if( localStorage.getItem(localstrKey)!=null)
     {
        setDatalist( JSON.parse(localStorage.getItem(localstrKey)));
        return;
     }else{
        FillDetail(itemselected.serviceId);
     }
      }
    }
  }, []);

  const { sendRequest: getData } = useHttp();


  const FillDetail = (srId) => {
    getData(
      {
        url: `/api/getReortListByOrgIdServiceId/?orgId=${localStorage.getItem(
          "orgId"
        )}&serviceId=${srId}`,
      },
      (res) => {
        if (res) {
          console.log("report list", res)
          var localstrKey="service"+srId
          setDatalist(res);
          localStorage.setItem(localstrKey, JSON.stringify(res));
        }
      }
    );
  };



  const colors = [
    "#f39c12",
    "#e91e63",
    "#00c0ef",
    "#00a65a",
    "#d9534f",
    "#ff5733",
    "#9c27b0",
    "#ffc107",
    "#007bff",
    "#28a745",
  ];

  return (
    <div className="content-wrapper p-4 report-main-div">
      <div
        className="d-flex align-items-center justify-content-center mb-4"
        style={{ gap: "12px" }}
      >
        <img
          src={logo}
          alt="logo"
          style={{ width: "45px", height: "45px", objectFit: "contain" }}
        />

        <h4 className="text-uppercase m-0">Comprehensive Dashboard</h4>
      </div>



      {datalist && datalist.length === 0 && (
        <div className="text-center text-bold text-muted mt-5 my-5">
          Reports Not Found
        </div>
      )}

      <div className="row">
        {datalist?.map((item, index) => (
          <div className="col-md-4 mb-3" key={index}>
            <Link to={item.reportUrl} className="text-decoration-none">
              <div
                className="report-box d-flex align-items-center shadow-sm p-3 rounded"
              // style={{
              //   borderLeft: `10px solid ${colors[index % colors.length]}`,
              //   backgroundColor: "#fff",
              // }}
              >
                <div
                  className="icon-circle d-flex justify-content-center align-items-center mr-3"
                  style={{
                    backgroundColor: colors[index % colors.length],
                    color: "white",
                  }}
                >
                  <i className={`fas ${item.icon}`} />
                </div>
                <div className="report-name text-dark font-weight-bold">
                  {item.name}
                </div>
              </div>
            </Link>
          </div>
        ))}
      </div>

      <style>{`
      .report-main-div{
       background:#f9f9f9;
      }
        .report-box {
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          border-radius: 12px;
          background:#FBF5DE;
        }
        .report-box:hover {
          transform: translateY(-4px);
          box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
        }
        .icon-circle {
          width: 45px;
          height: 45px;
          border-radius: 50%;
          font-size: 18px;
          flex-shrink: 0;
        }
        .report-name {
          font-size: 16px;
        }
      `}</style>
    </div>
  );
};

export default FarmerWiseMIS;
